document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-mobile-menu]');
  const overlay = document.querySelector('[data-menu-overlay]');
  const menuButtons = document.querySelectorAll('[data-menu-toggle]');
  const setMenu = (open) => {
    if (!menu || !overlay) return;
    menu.hidden = !open;
    overlay.hidden = !open;
    document.body.classList.toggle('menu-open', open);
    menuButtons.forEach(btn => btn.setAttribute('aria-expanded', open ? 'true' : 'false'));
  };
  menuButtons.forEach(btn => btn.addEventListener('click', () => setMenu(menu ? menu.hidden : true)));
  if (overlay) overlay.addEventListener('click', () => setMenu(false));

  const searchBtn = document.querySelector('[data-search-toggle]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  if (searchBtn && searchDrawer) {
    searchBtn.addEventListener('click', () => {
      searchDrawer.hidden = !searchDrawer.hidden;
      if (!searchDrawer.hidden) searchDrawer.querySelector('input')?.focus();
    });
  }

  document.querySelectorAll('[data-slider]').forEach(slider => {
    const slides = [...slider.querySelectorAll('.hero-slide')];
    const dots = [...slider.querySelectorAll('[data-slide-dot]')];
    let current = 0;
    const show = (index) => {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      slides.forEach((s,i) => s.classList.toggle('is-active', i === current));
      dots.forEach((d,i) => d.classList.toggle('is-active', i === current));
    };
    slider.querySelector('[data-slide-next]')?.addEventListener('click', () => show(current + 1));
    slider.querySelector('[data-slide-prev]')?.addEventListener('click', () => show(current - 1));
    dots.forEach((d,i) => d.addEventListener('click', () => show(i)));
    if (slides.length > 1) setInterval(() => show(current + 1), 6500);
  });

  document.querySelectorAll('[data-product-thumb]').forEach(btn => {
    btn.addEventListener('click', () => {
      const main = document.querySelector('#ProductMainImage');
      if (main) main.src = btn.dataset.productThumb;
    });
  });

  document.querySelectorAll('[data-sort-select]').forEach(select => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });
});